var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconButtonFacebook = function SvgIconButtonFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-button-facebook",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle_button",
    "data-name": "circle button"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle_button-2",
    "data-name": "circle button",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "rgba(255,255,255,0)",
    stroke: "#f2f2f2",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-facebook",
    transform: "translate(13.765 8.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-facebook-2",
    "data-name": "icon-facebook",
    d: "M826.134 56.963h-2.876c-1.707 0-3.606.718-3.606 3.192.008.862 0 1.688 0 2.617h-1.975v3.143h2.036v9.047h3.741v-9.106h2.47l.224-3.092h-2.758s.006-1.375 0-1.775c0-.978 1.017-.921 1.079-.921h1.668v-3.1Z",
    transform: "translate(-817.677 -56.963)",
    fill: "#245a9d"
  })))));
};
export { SvgIconButtonFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNyIgaGVpZ2h0PSIzNyIgdmlld0JveD0iMCAwIDM3IDM3Ij4KICA8ZyBpZD0iaWNvbi1idXR0b24tZmFjZWJvb2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAwLjUpIj4KICAgIDxnIGlkPSJjaXJjbGVfYnV0dG9uIiBkYXRhLW5hbWU9ImNpcmNsZSBidXR0b24iPgogICAgICA8Y2lyY2xlIGlkPSJjaXJjbGVfYnV0dG9uLTIiIGRhdGEtbmFtZT0iY2lyY2xlIGJ1dHRvbiIgY3g9IjE4IiBjeT0iMTgiIHI9IjE4IiBmaWxsPSJyZ2JhKDI1NSwyNTUsMjU1LDApIiBzdHJva2U9IiNmMmYyZjIiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPC9nPgogICAgPGcgaWQ9Imljb24tZmFjZWJvb2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjc2NSA4LjUpIj4KICAgICAgPHBhdGggaWQ9Imljb24tZmFjZWJvb2stMiIgZGF0YS1uYW1lPSJpY29uLWZhY2Vib29rIiBkPSJNODI2LjEzNCw1Ni45NjNoLTIuODc2Yy0xLjcwNywwLTMuNjA2LjcxOC0zLjYwNiwzLjE5Mi4wMDguODYyLDAsMS42ODgsMCwyLjYxN2gtMS45NzV2My4xNDNoMi4wMzZ2OS4wNDdoMy43NDFWNjUuODU2aDIuNDdsLjIyNC0zLjA5Mkg4MjMuMzlzLjAwNi0xLjM3NSwwLTEuNzc1YzAtLjk3OCwxLjAxNy0uOTIxLDEuMDc5LS45MjFoMS42Njh2LTMuMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04MTcuNjc3IC01Ni45NjMpIiBmaWxsPSIjMjQ1YTlkIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";